import React, { useState } from "react";
import PropTypes from "prop-types";
import Text from "@/bit/components/components.text";
import CmsClickToCall from "../cms-click-to-call";
import Alert from "../cms-alert";
import StepItem from "./step-item";

const StepList = (props) => {
  const [isC2CVisible, setIsC2CVisible] = useState(false);

  const {
    c2cProps,
    stepsProps,
    alertProps,
    alias,
    cmsHandler,
    blockName,
    CmsAddElement,
    CmsEditableGroupIcons,
  } = props;

  const titleProps = stepsProps["cms-atom-text-1"];
  const characValues = stepsProps["cms-ml-single-step-list"];
  const hideStepNumbers = stepsProps["hideStepNumbers"];
  const wrapElementsOnDivs =
    stepsProps?.wrapElementsOnDivs || cmsHandler || false;
  const className = props?.className;
  const itemIdDotNotation = `${blockName}${
    blockName === "cms-module-characteristics-and-steps-1"
      ? `.cms-component-steps-list-1`
      : ""
  }.cms-ml-single-step-list`;

  // Add Element Props
  const addProps = {
    contentId: blockName,
    itemIdDotNotation,
    layout: "vertical",
    small: true,
  };

  if (wrapElementsOnDivs) {
    return (
      <div>
        {titleProps && (
          <div className={`${className} steps-characteristics--title`}>
            <Text {...titleProps} cmsHandler={cmsHandler} />
          </div>
        )}
        <div className="steps-characteristics">
          {/* Bolitas de edicion aqui */}
          {CmsEditableGroupIcons && (
            <CmsEditableGroupIcons
              elementProps={{
                ...props,
                ...stepsProps,
                editName: "cms-block.cms-component-steps-and-c2c",
              }}
              deleteProps={{}}
              visibleTools={{
                hiring: false,
                edit: true,
                deleteItem: false,
              }}
              cmsHandler={cmsHandler}
            />
          )}
          {CmsAddElement && (
            <CmsAddElement
              addProps={{
                index: "start",
                ...addProps,
              }}
              cmsHandler={cmsHandler}
            />
          )}
          {characValues &&
            Array.isArray(characValues) &&
            characValues.length > 0 &&
            characValues.map((charac, i) => {
              return (
                <StepItem
                  className={props?.className}
                  charac={charac}
                  index={i}
                  cmsHandler={cmsHandler}
                  displayLine={i < characValues.length - 1}
                  hideStepNumbers={hideStepNumbers}
                  key={`charact-item-${i}`}
                  alias={alias}
                  frontalListToDelete={characValues}
                  itemIdDotNotation={itemIdDotNotation}
                  CmsEditableGroupIcons={CmsEditableGroupIcons}
                />
              );
            })}
          {CmsAddElement && (
            <CmsAddElement
              addProps={{
                index: "end",
                ...addProps,
              }}
              cmsHandler={cmsHandler}
            />
          )}
        </div>
        <CmsClickToCall
          cmsHandler={cmsHandler}
          {...c2cProps}
          setIsC2CVisible={setIsC2CVisible}
        />
        {(isC2CVisible || cmsHandler) && alertProps && (
          <div className="schedule">
            <Alert {...alertProps} cmsHandler={cmsHandler} />
          </div>
        )}
        <style jsx>{`.steps-characteristics {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: white;
  :global(&--title) {
    margin-bottom: 1.5rem;
  }
}

.schedule {
  display: flex;
  gap: 0.5rem;
  align-items: center;
  position: relative;
}
`}</style>
      </div>
    );
  }

  return (
    <>
      {titleProps && (
        <Text
          {...titleProps}
          className={`${className} steps-characteristics--title`}
        />
      )}
      {characValues &&
        Array.isArray(characValues) &&
        characValues.length > 0 &&
        characValues.map((charac, i) => {
          return (
            <StepItem
              className={className}
              charac={charac}
              index={i}
              displayLine={i < characValues.length - 1}
              key={`charact-item-${i}`}
              hideStepNumbers={hideStepNumbers}
            />
          );
        })}
      {c2cProps && (
        <div className={props?.className}>
          <CmsClickToCall
            cmsHandler={cmsHandler}
            {...c2cProps}
            setIsC2CVisible={setIsC2CVisible}
          />
          {alertProps && isC2CVisible && (
            <div className="schedule">
              <Alert {...alertProps} cmsHandler={cmsHandler} />
            </div>
          )}
        </div>
      )}

      {/* INJECT_STYLED_JSX_TAG */}
    </>
  );
};

StepList.propTypes = {
  /**
   * {
   *  "info": "Ocultar numeros del listado de pasos",
   *  "kind": "both",
   *  "beautifulName": "Ocultar Núméros"
   * }
   */
  hideStepNumbers: PropTypes.bool,
};

StepList.defaultProps = {
  hideStepNumbers: false,
};

export default StepList;
